// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileMarkdownTwoToneSvg from "@fishx/icons-svg/es/asn/FileMarkdownTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownTwoToneSvg
  }));
};

FileMarkdownTwoTone.displayName = 'FileMarkdownTwoTone';
export default React.forwardRef(FileMarkdownTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileMarkdownTwoTone.js
// module id = 2719
// module chunks = 0